import { combineReducers } from "redux";
import { loaderReducer } from "./Reducers/LoaderReducer";
import toastReducer from "./Reducers/ToastReducer";

const rootReducer = combineReducers({
  loaderReducer,
  toastReducer,
});

export default rootReducer;
